export default "/app/themes/majeures/build/images/logo_partners_white.svg?1011442bca75f6d4bb9ca859c01d0fe7";